import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AgentsState } from './agents.reducer';

export const selectAgentsDataState = createFeatureSelector<AgentsState>('agents');

export const selectAgentsList = createSelector(
  selectAgentsDataState,
  (state: AgentsState) => { console.log('state', state);
   return state.list}
);

export const selectAgentsPagination = createSelector(
  selectAgentsDataState,
  (state: AgentsState) => ({
      pageNumber: state.pageNumber,
      pageSize: state.pageSize,
      totalPages: state.totalPages,
      totalRecords: state.totalRecords
  })
);

export const selectAgentsDataLoading = createSelector(
    selectAgentsDataState,
    (state: AgentsState) => state.loading
);

export const selectAgentsDataError = createSelector(
    selectAgentsDataState,
    (state: AgentsState) => state.error
);

export const selectActiveAgentsList = createSelector(
  selectAgentsList,
  (agents) => agents
    .filter(agent => agent.isActive)
    .map(agent => ({ ...agent, checked: 0 }))
);
